/**
 * withUserPreferences
 * HOC for wrapping the provided component with UserPreferencesProvider
 */

import React from 'react'

import UserPreferencesProvider from './user-preferences-provider'

export default function withUserPreferences (WrappedComponent) {
  return function UserPreferencesProviderHOC(props) {
    return (
      <UserPreferencesProvider>
        <WrappedComponent {...props} />
      </UserPreferencesProvider>
    )
  }
}
